/**
 * Created by shubham on 24/4/18.
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {PartnersPageData} from "./partners-dashboard/partners-datatable/partners-page-data";
import {PartnersDashboardList} from "./partners-dashboard/partners-datatable/partnersDashboardList";
import {PartnersPage} from "./partners-dashboard/partners-datatable/partners-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class PartnersDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    partnersDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: PartnersPage,listData): Observable<PartnersPageData<PartnersDashboardList>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: PartnersPage): PartnersPageData<PartnersDashboardList> {
        let pageData = new PartnersPageData<PartnersDashboardList>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new PartnersDashboardList(jsonObj['id'], jsonObj['Name'], jsonObj['roleName'], jsonObj['email'],
                        jsonObj['emailVerified'], jsonObj['userId_WPASS'], jsonObj['languageId'], jsonObj['languageName'],
                        jsonObj['status'], jsonObj['ownerId'], jsonObj['sessionUserManager'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/partnersDashboardResultService.ts